export interface ApiBaseUrlEnvironment {
  readonly VITE_APP_API_URL?: string;
}

const DEFAULT_ENVIRONMENT: ApiBaseUrlEnvironment = import.meta.env;

let cachedDefaultApiBaseUrl: string | null = null;

const normalizeApiBaseUrl = (value: string | undefined): string => value?.trim().replace(/\/+$/, '') ?? '';

const logResolvedApiBaseUrl = (base: string): void => {
  if (base) {
    // eslint-disable-next-line no-console -- Диагностика escape-hatch видна в браузере на уровне Verbose.
    console.debug('[api-base] абсолютный базовый URL', { base });

    return;
  }

  // eslint-disable-next-line no-console -- Диагностика same-origin режима видна в браузере на уровне Verbose.
  console.debug('[api-base] same-origin режим', {
    origin: typeof window === 'undefined' ? undefined : window.location.origin,
  });
};

export const resolveApiBaseUrl = (environment: ApiBaseUrlEnvironment = DEFAULT_ENVIRONMENT): string => {
  const shouldUseDefaultCache = environment === DEFAULT_ENVIRONMENT;

  if (shouldUseDefaultCache && cachedDefaultApiBaseUrl !== null) {
    return cachedDefaultApiBaseUrl;
  }

  const base = normalizeApiBaseUrl(environment.VITE_APP_API_URL);

  if (shouldUseDefaultCache) {
    cachedDefaultApiBaseUrl = base;
    logResolvedApiBaseUrl(base);
  }

  return base;
};
